import React from "react";
import YouTube from "react-youtube";
import { Row, Col } from "react-bootstrap";

function YouTubeVideoList() {
  const videoIdsUpcoming = [
    "rph2F0uX-A0",
    "6Cmu3oUvOkA",
    "aF08WVSvCok",
    "9Ik0Y8Pr3l0",
    "q0N7kKRHbmM",
    "XFkH5Z-ZtCk",
  ];

  const videoIdsTopRunning = [
    "uHcD4y6nIAA",
    "-6RRff2oCe0",
    "A4CbAkPb468",
    "RFYTKI38q4Q",
    "5et1oRVeziI",
    "FWHcd8TH7dE",
  ];

  const opts = {
    width: "100%",
    height: "200",
    playerVars: {
      autoplay: 0,
      rel: 0,
      modestbranding: 1,
    },
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Top Running Films */}
      <h4>Top Running Films</h4>
      <Row className="g-3">
        {videoIdsTopRunning.map((videoId) => (
          <Col xs={12} sm={6} md={4} key={videoId}>
            <YouTube videoId={videoId} opts={opts} />
          </Col>
        ))}
      </Row>

      {/* Upcoming Films */}
      <h4 className="mt-4">Upcoming Films</h4>
      <Row className="g-3">
        {videoIdsUpcoming.map((videoId) => (
          <Col xs={12} sm={6} md={4} key={videoId}>
            <YouTube videoId={videoId} opts={opts} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default YouTubeVideoList;
